import Vue from 'vue'
import VueI18n from 'vue-i18n'
import tMessage from '@/config/i18n/locales/message'

Vue.use(VueI18n)

let language = ["ko","en","in"]
function makeLangMessage (lang) {
    let langMessages = {}
    let messageKeys = Object.keys(tMessage)
    for(let m in messageKeys) {
        let key = messageKeys[m]
        langMessages[key] = tMessage[key][lang]
    }
    return langMessages
}

function loadLocaleMessages() {
    const messages = {}
    language.forEach(function(lang) {
        messages[lang] = makeLangMessage(lang)
    })
    return messages
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
})
